//
//
//
//
//
//
//
//
//
//
//
//
//
//

// noinspection JSUnusedGlobalSymbols
import SkillName from '@/components/tasks/SkillName'
export default {
  name: 'RequiredSkills',
  components: { SkillName },
  props: {
    skills: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
